import React from "react";
import useReveal from "../hooks/useReveal";

export default function Reveal({ children, className = "", delay = 0, as: Tag = "div", ...rest }) {
  const [ref, shown] = useReveal();
  return (
    <Tag
      ref={ref}
      {...rest}
      style={{ transitionDelay: `${delay}ms` }}
      className={`transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)] will-change-transform ${shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${className}`}
    >
      {children}
    </Tag>
  );
}
